import React from 'react';
import classNames from 'classnames';
import styles from './RowStatsBox.module.scss';
import Trend from '../Trend/Trend';

export interface RowStatsBoxItem {
  label: string;
  score: string;
  trend: number;
}

export interface RowStatsBoxProps {
  layout?: 'box' | 'row';
  unit: string;
  data: RowStatsBoxItem[];
}

const RowStatsBox: React.FC<RowStatsBoxProps> = ({ layout = 'box', unit, data }) => {
  return (
    <div className={classNames(styles.root, { [styles.box]: layout === 'box', [styles.row]: layout === 'row' })}>
      <div
        className={classNames('grid', {
          'grid-cols-2 h-full': layout === 'box',
          'grid-cols-2 lg:grid-cols-4': layout === 'row',
        })}>
        {data.map(item => (
          <div key={item.label} className={styles.item}>
            <div
              className={classNames({
                'typo-text-14 text-faded pb-16': layout === 'box',
                'typo-text-14--bold text-full pb-36': layout === 'row',
              })}>
              {item.label}
            </div>
            <div className="flex flex-col gap-y-12 mt-auto">
              <div className="typo-title-24 xl:typo-title-36 text-full">
                {item.score}
                {unit}
              </div>
              <Trend percentage={item.trend} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RowStatsBox;
